module.exports = __webpack_public_path__ + "static/img/dn5-mayor.144da22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn5-mayor.png
// module id = Y01I
// module chunks = 0